import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../../constants/common'
import { NotificationInline } from '../../../Notification'
import { QA_NAME_OVERVIEW_PERIOD_ERROR } from '../RentalPortalOverviewPeriodSelect'

import RefreshIcon from '../../../../icons/refresh.svg'

function RentalPortalOverviewRefreshError({ onRetry }) {
  const { t } = useTranslation()

  return (
    <NotificationInline
      actions={[
        {
          beforeIconProps: { Icon: RefreshIcon },
          callback: onRetry,
          text: t('RentalPortal.ListingRetryBtnKey'),
        },
      ]}
      qaName={QA_NAME_OVERVIEW_PERIOD_ERROR}
      text={t('RentalPortal.OverviewRefreshErrorKey')}
      type={NOTIFICATION_TYPE.error}
    />
  )
}

export default RentalPortalOverviewRefreshError
